import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import PurchaseOrderLayer from "../../../components/Admin/PurchaseOrderLayer";

const PurchaseOrder = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <PurchaseOrderLayer />
      </MasterLayout>
    </>
  );
};

export default PurchaseOrder